import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-hang-tight',
  templateUrl: './hang-tight.component.html',
  styleUrls: ['./hang-tight.component.scss'],
  standalone: false
})
export class HangTightComponent {
  @Input() isErrorLoadingScreen: boolean = false;
  @Input() displayButtonLoadingScreen: boolean = false;
  @Input() titleLoadingScreen: string = '';
  @Input() messageLoadingScreen: string = '';
  @Input() pastDate: boolean = false;

  constructor(private router: Router) {}

  navigateToRoute() {
    this.router.navigate(['/assignments']);
  }
}
